export const cl_verge3dContainer = 'v3d-container'; // id and class for specific div
export const cl_floatWindowContent = 'float-window__content';
export const cl_floatWindowResizer = 'float-window__resizer';
export const cl_v3dCanvas = 'v3d-canvas';
